import axios from '../../utils/axios2';

export default {

    namespaced: true,

    state: {
        truckBrand: null,
        truckBrands: null
    },

    mutations: {
        setTruckBrand(state, payload) {
            state.truckBrand = payload;
        },
        setTruckBrands(state, payload) {
            state.truckBrands = payload
        }
    },

    actions: {
        storeTruckBrand({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `truck-brands`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        updateTruckBrand({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `truck-brands/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        removeTruckBrand({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `truck-brands/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        fetchTruckBrand({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `truck-brands/${payload}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setTruckBrand", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
        fetchTruckBrands({commit, rootState}) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `truck-brands`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setTruckBrands", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
            });
        }
    }

}